import { z } from "zod";

import { chillnnPasswordZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const authSignInInputZodSchema = z.object({
	email: z.string().email(),
	password: chillnnPasswordZodSchema,
});

export type AuthSignInInputType = z.infer<typeof authSignInInputZodSchema>;
